module.exports = __webpack_public_path__ + "img/google-cloud.448f2f75.svg";